<template>
    <div class="row">
        <div class="col-lg-12">
            <div class="row">
                <div class="col-lg-12">
                    <label>{{ t('Name') }}</label>
                    <input type="text" :value="name" class="form-control" id="name" @keyup="getName($event)">
                    <span v-if="errors && errors.name" class="error">{{ t(errors.name) }}</span>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <h4>{{ t('Formulas') }}</h4>
                    <drag v-for="item in formulaService.getAll()"
                          class="drag btn btn-info" :data="item">
                        {{ item.getName() }}
                    </drag>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <h4>{{ t('Arguments') }}</h4>
                    <drag v-for="item in formulaAttributesService.getAll()"
                          class="drag btn btn-info"
                          :data="item">
                        {{ item.getName() }}
                    </drag>
                </div>
            </div>
            <div class="row">
                <div class="col-lg-12">
                    <h4>{{ t('Value') }}</h4>
                    <drag v-for="item in formulaValueService.getAll()"
                          class="drag btn btn-info"
                          :data="item">
                        {{ item.getName() }}
                    </drag>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import FormulaService from "@/Models/pricingRulesInterface/FormulaService.ts";
import {Drag} from "vue-easy-dnd";

export default {
    name: "recursive-drop",
    components: {
        Drag,
    },
    props: {
        name: {
            Type: String
        },
        errors: {
            Type: Object
        },
        formulaService: {
            Type: FormulaService
        },
        formulaAttributesService: {
            Type: FormulaService
        },
        formulaValueService: {
            Type: FormulaService
        }
    },
    methods: {
        getName(event) {
            this.$emit("getName", event.target.value);
        }
    }
}

</script>


// WEBPACK FOOTER //
// DragComponent.vue?40b76c25